<template>
  <v-app :style="appStyle">
    <AppBar 
      @toggle="toggleAppDrawer(!isDrawerOpen)"
      @toggleMobile="toggleMobileDrawer"
    />
    
    <!-- Mobile : AppDrawer avec liens dynamiques selon la route -->
    <AppDrawer
      v-if="isMobile"
      :isOpen="isDrawerOpen"
      :isMobile="isMobile"
      @toggle="toggleAppDrawer"
    />

    <!-- Desktop : sidebar permanente selon la route -->
    <component
      v-if="contentDrawer && !isMobile"
      :is="contentDrawer"
    ></component>
    
    <v-main>
      <CoreView />
    </v-main>
    <SnackBar />
    <AppDialog />
  </v-app>
</template>

<script>
import { getTheme, getAssets } from "@/plugins/vuetify"

export default {
  components: {
    AppBar: () => import("@/components/layouts/core/AppBar.vue"),
    AppDialog: () => import("@/components/utils/GlobalDialog.vue"),
    AppDrawer: () => import("@/components/layouts/core/AppDrawer.vue"),
    CoreView: () => import("@/components/layouts/core/View.vue"),
    SnackBar: () => import("@/components/utils/ErrorHandler.vue")
  },
  data() {
    return {
      isDrawerOpen: false
    }
  },
  computed: {
    appStyle() {
      let theme = getTheme(this)
      let assets = getAssets(this, "common")
      return {
        backgroundAttachement: "fixed",
        backgroundColor: theme.background,
        backgroundImage: `url(${assets.background})`,
        backgroundPosition: "bottom right",
        backgroundRepeat: "no-repeat",
        overflowX: "hidden" 
      }
    },
    contentDrawer() {
      return this.$route.meta?.drawer
    },
    hasProjectDrawer() {
      // Vérifier si la route actuelle a un drawer défini
      return !!this.$route.meta?.drawer
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  watch: {
    // Fermer le drawer automatiquement quand on passe en desktop
    isMobile(newVal) {
      if (!newVal) {
        this.isDrawerOpen = false
      }
    },
    // Fermer le drawer quand on change de page
    '$route'() {
      if (this.isMobile) {
        this.isDrawerOpen = false
      }
    }
  },
  methods: {
    onClick() {
      this.$store.commit("drawer/setMainDrawer", !this.$store.state.drawer.main)
    },
    toggleAppDrawer(newValue) {
      this.isDrawerOpen = newValue
    },
    toggleMobileDrawer() {
      // Toggle spécifique pour mobile
      this.isDrawerOpen = !this.isDrawerOpen
    }
  }
}
</script>